import { Box, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useRouter } from 'next/router';
import { FC, ReactNode, useMemo } from 'react';
import { Logout } from '@mui/icons-material';
import { useFacilityId } from '@src/hooks/patient-services/useFacilityId';
import { useAppStore } from '@src/store';
import { iconMap, matchRouteWithItem, navigationItems } from '../PatientServicesNavigationHelpers';
import { listItemsWrapper, logoutItemWrapper, menuItemWrapper, menuList, navigationWrapper } from './PatientServicesDesktopNavigation.styles';
type PatientServicesLayoutProps = {
  magicLogout: () => void;
  handleLinkTracking: (linkText: string, linkUrl: string) => void;
  children: ReactNode;
};
const PatientServicesDesktopNavigation: FC<PatientServicesLayoutProps> = ({
  magicLogout,
  handleLinkTracking,
  children
}) => {
  const {
    facilityId
  } = useFacilityId();
  const {
    pathname
  } = useRouter();
  const {
    documentsAndRecordsLocations
  } = useAppStore(store => store.officeRollout);
  const visibleNavigationItems = useMemo(() => {
    return navigationItems.filter(menuItem => {
      const isDocsAndRecordsRoute = menuItem.redirect === '/patient-services/documents-and-records';
      if (!isDocsAndRecordsRoute) return true;
      return documentsAndRecordsLocations.includes(facilityId);
    });
  }, [facilityId, documentsAndRecordsLocations]);
  return <Box display="flex" data-sentry-element="Box" data-sentry-component="PatientServicesDesktopNavigation" data-sentry-source-file="PatientServicesDesktopNavigation.tsx">
			<Box sx={navigationWrapper} data-test-id="patient-portal-desktop-navigation" data-sentry-element="Box" data-sentry-source-file="PatientServicesDesktopNavigation.tsx">
				<MenuList sx={menuList} data-sentry-element="MenuList" data-sentry-source-file="PatientServicesDesktopNavigation.tsx">
					<Box sx={listItemsWrapper} data-sentry-element="Box" data-sentry-source-file="PatientServicesDesktopNavigation.tsx">
						{visibleNavigationItems.map(menuItem => {
            const {
              icon,
              title,
              redirect
            } = menuItem;
            const isActiveItem = matchRouteWithItem(title, pathname);
            const IconComponent = iconMap[icon];
            return <MenuItem key={title} onClick={() => handleLinkTracking(title, redirect)} sx={menuItemWrapper({
              isActiveItem
            })}>
									<IconComponent sx={{
                width: '1.5rem',
                height: '1.5rem'
              }} />
									<Typography variant={isActiveItem ? 'bodyMediumBold' : 'bodyMediumBook'}>
										{title}
									</Typography>
								</MenuItem>;
          })}
					</Box>
					<MenuItem onClick={magicLogout} sx={logoutItemWrapper} data-sentry-element="MenuItem" data-sentry-source-file="PatientServicesDesktopNavigation.tsx">
						<Logout sx={{
            width: '1.5rem',
            height: '1.5rem'
          }} data-sentry-element="Logout" data-sentry-source-file="PatientServicesDesktopNavigation.tsx" />
						<Typography variant="bodyMediumBook" data-sentry-element="Typography" data-sentry-source-file="PatientServicesDesktopNavigation.tsx">Logout</Typography>
					</MenuItem>
				</MenuList>
			</Box>
			{children}
		</Box>;
};
export default PatientServicesDesktopNavigation;